import { authService } from '../../../services/authService';

export const loginService = {
  /**
   * Executes the authentication request with credentials preprocessing
   * @param {Object} credentials - The email, password inputs, and captcha
   * @returns {Promise<Object>} The API response payload
   */
  executeLogin: async ({ email, password, captchaId, captchaText }) => {
    // Clean and normalize credential inputs before submission
    const normalizedCredentials = {
      email: email.trim().toLowerCase(),
      password,
      captchaId,
      captchaText
    };
    
    return await authService.login(normalizedCredentials);
  }
};
